var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilteredDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3668_81772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66679 3.00008H9.33345L5.99345 7.20008L2.66679 3.00008ZM0.833452 2.74008C2.18012 4.46675 4.66679 7.66675 4.66679 7.66675V11.6667C4.66679 12.0334 4.96679 12.3334 5.33345 12.3334H6.66679C7.03345 12.3334 7.33345 12.0334 7.33345 11.6667V7.66675C7.33345 7.66675 9.81345 4.46675 11.1601 2.74008C11.2365 2.64166 11.2838 2.52377 11.2964 2.39982C11.3091 2.27587 11.2868 2.15085 11.2319 2.039C11.177 1.92714 11.0918 1.83294 10.986 1.76713C10.8802 1.70132 10.758 1.66654 10.6335 1.66675H1.36012C0.806785 1.66675 0.493452 2.30008 0.833452 2.74008Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.75C12.5188 5.75 13.75 4.51878 13.75 3C13.75 1.48122 12.5188 0.25 11 0.25C9.48122 0.25 8.25 1.48122 8.25 3C8.25 4.51878 9.48122 5.75 11 5.75Z",
    fill: "#F6976D",
    stroke: "#F4F6F8",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3668_81772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilteredDataIcon);
export default __webpack_public_path__ + "static/media/filtered-data-icon.f04e07ed3b78360a4bcfb4dda9a1cf32.svg";
export { ForwardRef as ReactComponent };